export function useCoreApi(basePath: `${'external' | 'ecommerce'}/${string}`) {
  const auth = useAuthorizeStore()

  const requestHeaders = useRequestHeaders(['authorization'])

  return {
    endpoint(...parts: (string | undefined)[]) {
      if (parts.includes(undefined)) {
        throw new Error(`Endpoint had invalid parts: ${parts.join(', ')}`)
      }

      return parts.join('/')
    },

    $fetch: $fetch.create({
      baseURL: `/api/core/${basePath}`,
      async onRequest({ options }) {
        const headers = await auth.headers()
        const authorization = headers?.Authorization ?? requestHeaders?.authorization
        if (authorization) {
          options.headers.set('Authorization', authorization)
        }
      },
    }),
  }
}
